<template>
    <div class="process">

        <h3>Informazioni utente</h3>

        <div class="input boxRow">
            <div>
                <strong>Consumo</strong>
                {{consumo}} Smc/anno
            </div>
            <div>
                <strong>Potenza</strong>
                {{potenza}} kw
            </div>
            <div>
                <strong>Regione</strong>
                {{regione}}
            </div>
        </div>

        <div class="scaglioni boxRow">
            <div>
                <strong>Trasporto e gestione</strong>
                <scaglioni :values="trasporto.scaglioni" :type="'gas'" />
                <br>
                Canone: {{trasporto.fisso}}
            </div>
            <div>
                <strong>Oneri di sistema</strong>
                <scaglioni :values="oneri.scaglioni" :type="'gas'" />
            </div>
            <div>
                <strong>Accisa</strong>
                <scaglioni :values="accisa.scaglioni" :type="'imposte'" />
            </div>
            <div>
                <strong>Addizionale Regionale</strong>
                <scaglioni :values="addizionaleRegionale.scaglioni" :type="'imposte'" />
            </div>
            <div>
                <strong>Costo energia</strong>
                perdite = {{energy.perdite}}<br>
                PD = {{energy.PD}}<br>
                DISPbt = {{energy.DISPbt}}<br>
                PPE = {{energy.PPE}}<br>
                oneri.prezzo = {{energy.oneri.prezzo}}<br>
                <i class="hide">oneri</i>.canone = {{energy.oneri.canone}}<br>
                trasporto.prezzo = {{energy.trasporto.prezzo}}<br>
                <i class="hide">trasporto</i>.canone = {{energy.trasporto.canone}}<br>
                <i class="hide">trasporto</i>.prezzoPotenza = {{energy.trasporto.prezzoPotenza}}<br>
            </div>
            <div>
                <strong>Iva</strong>
                Intera = {{Iva.intera}}<br>
                Ridotta = {{Iva.ridotta}}<br>
            </div>
        </div>

        <h3>Stime prodotti</h3>

        <div class="product boxRow">
            <div class="product-name">
                LINK Gas
            </div>
            <div>
                <strong>Costo Energia Gas</strong>
                {{g}} €/Smc
            </div>
            <div>
                <strong>Stima annua Gas</strong>
                {{stimaAnnua}} €/Smc
            </div>
        </div>

        <div class="partials boxRow">
            <div>
                <strong>Prezzo Materia Energia</strong>
                <span class="tooltip"><span v-html="prezzoEnergiaScaglioniDescription"></span>( energia + commercializzazione ) * consumo * IVA scaglioni</span> + canone * IVA intere<br>
                <!--( energia + commercializzazione ) * consumo * IVA ridotta + canone * IVA intere<br>-->
                ( {{g}} + {{qvd.variabile}} ) * {{consumo}} * {{Iva.ridotta}} + {{qvd.fisso}} * {{Iva.intera}}
                <div class="result">
                    <strong>Prezzo Materia Energia</strong>
                    {{prezzoMateriaEnergia}} €/anno
                </div>
            </div>
            <div>
                <strong>Trasporto</strong>
                <span class="tooltip"><span v-html="prezzoTrasportoScaglioniDescription"></span>prezzo scaglioni</span> + canone * Iva.intera<br>
                {{prezzoTrasportoScaglioni}} + {{trasporto.fisso}} * {{Iva.intera}}
                <div class="result">
                    <strong>Trasporto</strong>
                    {{prezzoTrasporto}} €/anno
                </div>
            </div>
            <div>
                <strong>Oneri</strong>
                <span class="tooltip"><span v-html="prezzoOneriScaglioniDescription"></span>prezzo scaglioni</span> + canone * Iva.intera<br>
                {{prezzoOneriScaglioni}} + {{oneri.fisso}} * {{Iva.intera}}
                <div class="result">
                    <strong>Oneri</strong>
                    {{prezzoOneri}} €/anno
                </div>
            </div>
            <div>
                <strong>Accisa</strong>
                <span class="tooltip"><span v-html="prezzoAccisaScaglioniDescription"></span>prezzo scaglioni</span><br>
                {{prezzoAccisaScaglioni}}
                <div class="result">
                    <strong>Accisa</strong>
                    {{prezzoAccisa}} €/anno
                </div>
            </div>
            <div>
                <strong>Addizionale Regionale</strong>
                <span class="tooltip"><span v-html="prezzoAddizionaleRegionaleScaglioniDescription"></span>prezzo scaglioni</span><br>
                {{prezzoAddizionaleRegionale}}
                <div class="result">
                    <strong>Addizionale Regionale</strong>
                    {{prezzoAddizionaleRegionale}} €/anno
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import scaglioni from '../components/Scaglioni.vue';

import Trasporto from "../model/Trasporto.js";
import Oneri from "../model/Oneri.js";
import Accisa from "../model/Accisa.js";
import AddizionaleRegionale from "../model/AddizionaleRegionale.js";
import Iva from "../model/Iva.js";

import { EnergyCosts } from "../model/Costs.js";

export default {
    name: "Gas",
    components: {
        scaglioni
    },
    props: {
        potenza: Number,                //- potenza impianto utente ---
        consumo: Number,                //- consumo annuo dichiarati dall'utente ---
        regione: String,                //- regione appartenenza ---
    },
    data() { 
        return {
            loaded: false,
            logMessage: '',
            g: 0.18,                    //- prezzo materia prima --- per la lionk c'è un prezzo ad hoc
            qvd: {                      //- componente di commercializzazione ---
                fisso: 90,              //- canone ---     
                variabile: 0.007946
            },
            scaglioni: [
                0, 120, 480, 1560, 5000, 80000
            ],
            prezzo: {
                materia: 0,
                trasporto: 0,
                oneri: 0,
                accisa: 0,
                totale: 0
            },
            Iva: {
                intera: 0,
                ridotta: 0
            },
            energy: {
                perdite:0,
                PD:0,
                DISPbt:0,
                PPE:0,
                oneri:0,
                trasporto:0
            }
        };
    },
    mounted() {
        console.log( 'Result mounted', this.consumo, this.potenza, this.regione );

        this.energy.perdite = EnergyCosts.perdite;
        this.energy.PD = EnergyCosts.PD;
        this.energy.DISPbt = EnergyCosts.DISPbt;
        this.energy.PPE = EnergyCosts.PPE;
        this.energy.oneri = EnergyCosts.oneri;
        this.energy.trasporto = EnergyCosts.trasporto;

        this.Iva.intera = Iva.intera;
        this.Iva.ridotta = Iva.ridotta;
        this.Iva.soglia = Iva.soglia;

        //- Materia energia ---
            this.prezzo.materia = this.prezzoMateriaEnergia;
        //- Traposto ---
            this.prezzo.trasporto = this.prezzoTrasporto;
        //- Oneri ---
            this.prezzo.oneri = this.prezzoOneri;
        //- Accisa, spesa ante imposta iva ---
            this.prezzo.accisa = this.prezzoAccisa;
        //- Accisa, spesa ante imposta iva ---
            this.prezzo.addizionaleRegionale = this.prezzoAddizionaleRegionale;

        //- Costo annuo utente ---
            this.prezzo.totale = this.stimaAnnua;
            
    },
    computed: {
        trasporto: function(){
            return Trasporto.getCluster( this.regione );
        },
        oneri: function(){
            return Oneri.getCluster( this.regione );
        },
        accisa: function(){
            return Accisa.getCluster( this.regione );
        },
        addizionaleRegionale: function(){
            return AddizionaleRegionale.getCluster( this.regione, 'base' );  
        },
        prezzoEnergiaScaglioni: function(){
            let price = this.g + this.qvd.variabile;
            console.log('prezzoEnergiaScaglioni', "("+this.g+" + "+this.qvd.variabile+") * "+this.consumo+" = "+price );
            return this.scalaScaglioni( price );
        },
        prezzoEnergiaScaglioniDescription: function(){
            let price = this.g + this.qvd.variabile;
            console.log('prezzoEnergiaScaglioniDescription', "("+this.g+" + "+this.qvd.variabile+") * "+this.consumo+" = "+price );
            return this.scalaScaglioniDescription( price );
        },
        prezzoMateriaEnergia: function(){
            console.log('PREZZO MATERIA ENERGIA', this.prezzoEnergiaScaglioni );
            console.log('PREZZO MATERIA ENERGIA', ( (this.g + this.qvd.variabile) * this.consumo * Iva.ridotta + this.qvd.fisso * Iva.intera ) );
            console.log('PREZZO MATERIA ENERGIA', '('+this.g+' + '+this.qvd.variabile+') * '+this.consumo+' * '+Iva.ridotta+' + '+this.qvd.fisso+' * '+Iva.intera+' )' );
            console.log('PREZZO MATERIA ENERGIA', (this.g + this.qvd.variabile) * this.consumo * Iva.ridotta + this.qvd.fisso * Iva.intera );
            console.log('PREZZO MATERIA ENERGIA', this.prezzoEnergiaScaglioni + this.qvd.fisso * Iva.intera );
            return this.prezzoEnergiaScaglioni + this.qvd.fisso * Iva.intera;
            // return (this.g + this.qvd.variabile) * this.consumo * Iva.ridotta + this.qvd.fisso * Iva.intera;
        },
        //- Trasporto ---
            prezzoTrasportoScaglioniDescription: function(){
                return this.scalaScaglioniDescription( this.trasporto.scaglioni );
            },
            prezzoTrasportoScaglioni: function(){
                return this.scalaScaglioni( this.trasporto.scaglioni );
            },
            prezzoTrasporto: function(){
                return this.prezzoTrasportoScaglioni + this.trasporto.fisso * Iva.intera;
            },
        //- Oneri ---
            prezzoOneriScaglioniDescription: function(){
                return this.scalaScaglioniDescription( this.oneri.scaglioni );
            },
            prezzoOneriScaglioni: function(){
                return this.scalaScaglioni( this.oneri.scaglioni );
            },
            prezzoOneri: function(){
                return this.prezzoOneriScaglioni + this.oneri.fisso * Iva.intera;
            },
        //- Accisa ---
            prezzoAccisaScaglioniDescription: function(){
                return this.scalaScaglioniDescription( this.accisa.scaglioni );
            },
            prezzoAccisaScaglioni: function(){
                return this.scalaScaglioni( this.accisa.scaglioni );
            },
            prezzoAccisa: function(){
                return this.prezzoAccisaScaglioni;
            },
        //- Addizionali regionali ---
            prezzoAddizionaleRegionaleScaglioniDescription: function(){
                return this.scalaScaglioniDescription( this.addizionaleRegionale.scaglioni );
            },
            prezzoAddizionaleRegionaleScaglioni: function(){
                return this.scalaScaglioni( this.addizionaleRegionale.scaglioni );
            },
            prezzoAddizionaleRegionale: function(){
                return this.prezzoAddizionaleRegionaleScaglioni;
            },
        //- Costo all'utente ---
            stimaAnnua: function(){
                return this.prezzo.materia +  this.prezzo.trasporto + this.prezzo.oneri + this.prezzo.accisa + this.prezzo.addizionaleRegionale;
            }
    },
    methods: {
        // mancano delle regioni sopratuttto nella Addizionale regionale
        // nell'addizionale la lombardia non è esclusa come da nota sotto la tabella?

        ivaScaglioni( prezzoTemp ){
            console.log('scalaScaglioni', prezzoTemp);

            let prezzo = [];
            if ( prezzoTemp.constructor === Array ){
                prezzo = prezzoTemp;
            } else {
                for (var i = 0; i < 6; i++) {
                    prezzo.push( prezzoTemp );
                }
            }

            console.log('scalaScaglioni', prezzo);

            let costo = 0;
            let consumo = this.consumo;
            for (let i = this.scaglioni.length; i >= 0; i--) {
                if ( consumo > this.scaglioni[i] && typeof(prezzo[i]) !== 'undefined' ){
                    let iva_step = ( Iva.soglia <= this.scaglioni[i] ) ? Iva.intera : Iva.ridotta;
                    costo += (consumo - this.scaglioni[i]) * prezzo[i] * iva_step;
                    consumo = this.scaglioni[i];
                }
            }
            return costo;
        },

        scalaScaglioni( prezzoTemp ){
            console.log('scalaScaglioni', prezzoTemp);

            let prezzo = [];
            if ( prezzoTemp.constructor === Array ){
                prezzo = prezzoTemp;
            } else {
                for (var i = 0; i < 6; i++) {
                    prezzo.push( prezzoTemp );
                }
            }

            console.log('scalaScaglioni', prezzo);

            let costo = 0;
            let consumo = this.consumo;
            for (let i = this.scaglioni.length; i >= 0; i--) {
                if ( consumo > this.scaglioni[i] && typeof(prezzo[i]) !== 'undefined' ){
                    let iva_step = ( Iva.soglia <= this.scaglioni[i] ) ? Iva.intera : Iva.ridotta;
                    costo += (consumo - this.scaglioni[i]) * prezzo[i] * iva_step;
                    consumo = this.scaglioni[i];
                }
            }
            return costo;
        },

        scalaScaglioniDescription( prezzoTemp ){
            console.log('scalaScaglioniDescription', prezzoTemp);

            let prezzo = [];
            if ( prezzoTemp.constructor === Array ){
                prezzo = prezzoTemp;
            } else {
                for (var i = 0; i < 6; i++) {
                    prezzo.push( prezzoTemp );
                }
            }

            console.log('scalaScaglioniDescription', prezzo);

            let html = '';
            let consumo = this.consumo;
            for (let i = this.scaglioni.length; i >= 0; i--) {
                if ( consumo > this.scaglioni[i] && typeof(prezzo[i]) !== 'undefined' ){
                    let iva_step = ( Iva.soglia <= this.scaglioni[i] ) ? Iva.intera : Iva.ridotta;
                    html = html + (consumo-this.scaglioni[i]) + " * " + prezzo[i] + " * " + iva_step + "<br>" ;
                    consumo = this.scaglioni[i];
                }
            }
            return html;
        },

        back(){
            this.$router.push({path: '/'});
        },

        onConsumoChange( elem ){
            console.log( elem );
            this.consumo =  elem.value;
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hide {opacity: 0;}

    .boxRow {
        display: flex; font-size: 12px; 
    }

    .boxRow > div {
        background: #FFF4BC; border: 1px solid #FFE978; padding: 15px; margin-bottom: 15px; 
    }

    .boxRow > .product-name {
        font-size: 27px; line-height: 27px;
    }

    .boxRow.scaglioni > div >>> span {
        display: inline-block; width: 150px;
    }
    
    .boxRow.scaglioni > div { 
        
    }

    .boxRow.partials {
        flex-direction: column; margin-bottom: 75px; max-width: 1140px;
    }

    .boxRow.partials > div {
        position: relative; margin-bottom: 0;
    }

    .boxRow > div > strong {
        display: block; margin-bottom: 9px; text-transform: uppercase;
    }

    .boxRow.partials > div .result {
        background: #FFE978; margin: 0; font-size: 16px; font-weight: 600; padding: 15px;

        width: 250px; position: absolute; right: 0; top: 0; bottom: 0; 
    }

    .boxRow.partials > div .result strong {
        font-size: 12px; margin-bottom: 9px; text-transform: uppercase; font-weight: 600; display: block;
    }

    .boxRow.partials > div .result::before { 
        content: '+'; border-radius: 50%; background: #fff; line-height: 20px; width: 20px; text-align: center; position: absolute; bottom: 0; transform: translateY(50%);
        z-index: 50;
    }

    .boxRow.partials > div:last-child .result::before { 
        content: '';
    }

    .tooltip {
        position: relative; display: inline-block; opacity: 1;
    }

    .tooltip > span { display: none; padding: 9px;
        position: absolute; bottom: 50px; left: 50%; width: 300px; background: #333; color: #fff;
    }

    .tooltip:hover > span { display: block; }
</style>